import { render, staticRenderFns } from "./oadashboard.vue?vue&type=template&id=3afd5e8e&scoped=true"
import script from "./oadashboard.vue?vue&type=script&lang=js"
export * from "./oadashboard.vue?vue&type=script&lang=js"
import style0 from "./oadashboard.vue?vue&type=style&index=0&id=3afd5e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd5e8e",
  null
  
)

export default component.exports